import { registerView, ViewComponent } from "@frui.ts/views";
import Tooltip from "controls/tooltip";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import { getTimeZoneLabel } from "utils/dateUtils";
import OrderRecapitulationViewModel from "viewModels/eshop/order/components/orderRecapitulationViewModel";

const OrderRecapitulationView: ViewComponent<OrderRecapitulationViewModel> = observer(({ vm }) => {
  const renderDateWithTimeZone = (date: Date) => {
    if (!date) {
      return vm.emptyState;
    }
    const formatted = vm.localizationService.formatDateTime(date);
    return !vm.isDifferentTimeZone ? (
      <span>{formatted}</span>
    ) : (
      <>
        <span>{formatted}</span>
        <Tooltip
          id="cet-tooltip"
          placement={isMobile ? "bottom" : "right"}
          tooltip={vm.localizationService.translateGeneral("timezoneTooltip")}
          trigger={["hover", "focus"]}>
          <span style={{ marginLeft: 4, textDecoration: "underline", textDecorationStyle: "dotted" }}>
            {getTimeZoneLabel(date)}
          </span>
        </Tooltip>
      </>
    );
  };

  return (
    <Card className="bg-transparent mb-6 border-0 text-break">
      <Row className="d-flex align-items-center justify-content-between px-3 px-md-0 mx-sm-1 mt-3">
        <Col xs="auto">
          <Row>
            <div className="mb-0 text-wrap">{vm.translate("vehicle")}</div>
          </Row>
        </Col>
        <Col xs="auto" className="flex-grow-1 text-right">
          <Row className="justify-content-end">
            <div className="font-weight-bold">{vm.vehicleSummaryInfo}</div>
          </Row>
        </Col>
      </Row>
      <Row className="d-flex align-items-center justify-content-between px-3 px-md-0 mx-sm-1 mt-3">
        <Col xs="auto">
          <Row>
            <div className="mb-0 text-wrap">{vm.translate("markType")}</div>
          </Row>
        </Col>
        <Col xs="auto" className="flex-grow-1 text-right">
          <Row className="justify-content-end">
            <div className="font-weight-bold">{vm.markSummaryInfo}</div>
          </Row>
        </Col>
      </Row>
      <Row className="d-flex align-items-center justify-content-between px-3 px-md-0 mx-sm-1 mt-3">
        <Col xs="auto">
          <Row>
            <div className="mb-0 text-wrap">{vm.translate("fuelType")}</div>
          </Row>
        </Col>
        <Col xs="auto" className="flex-grow-1 text-right">
          <Row className="justify-content-end">
            <div className="font-weight-bold">{vm.fuelTypeInfo}</div>
          </Row>
        </Col>
      </Row>
      <Row className="d-flex align-items-center justify-content-between px-3 px-md-0 mx-sm-1 mt-3">
        <Col xs="auto">
          <Row>
            <div className="mb-0 text-wrap">{vm.translate("validSince")}</div>
          </Row>
        </Col>
        <Col xs="auto" className="flex-grow-1 text-right">
          <Row className="justify-content-end">
            <div className="font-weight-bold">
              {vm.validitySinceInfo ? renderDateWithTimeZone(new Date(vm.validitySinceInfo)) : vm.emptyState}
            </div>
          </Row>
        </Col>
      </Row>
      <Row className="d-flex align-items-center justify-content-between px-3 px-md-0 mx-sm-1 mt-3">
        <Col xs="auto">
          <Row>
            <div className="mb-0 text-wrap">{vm.translate("validUntil")}</div>
          </Row>
        </Col>
        <Col xs="auto" className="flex-grow-1 text-right">
          <Row className="justify-content-end">
            <div className="font-weight-bold">
              {vm.validityUntilInfo ? renderDateWithTimeZone(new Date(vm.validityUntilInfo)) : vm.emptyState}
            </div>
          </Row>
        </Col>
      </Row>
      <Row className="d-flex align-items-center justify-content-between px-3 px-md-0 mx-sm-1 mt-3 pb-4">
        <Col xs="auto">
          <Row>
            <div className="mb-0 text-wrap">{vm.translate("email")}</div>
          </Row>
        </Col>
        <Col xs="auto" className="flex-grow-1 text-right">
          <Row className="justify-content-end">
            <div className="font-weight-bold">{vm.emailInfo}</div>
          </Row>
        </Col>
      </Row>
      <Row
        className="d-flex align-items-center justify-content-between px-sm-2 px-md-0 py-4 mx-0"
        style={{ borderBottom: "1px solid #E4E8EC", borderTop: "1px solid #E4E8EC" }}>
        <Col xs="auto">
          <Row>
            <h4 className="mb-0 text-wrap">{vm.translate("price")}</h4>
          </Row>
        </Col>
        <Col xs="auto">
          <Row>
            <h4 className="mb-0 text-wrap">{vm.priceSummaryInfo}</h4>
          </Row>
        </Col>
      </Row>
    </Card>
  );
});

registerView(OrderRecapitulationView, OrderRecapitulationViewModel);
